import styled from 'styled-components'
import { BREAK_POINT_MD } from '@CSSVars/variables'
import { GREY_BACKGROUND, TEXT_GREY, PRIMARY_SECONDARY_COLOR } from '@CSSVars/colors'

export const _Overlay = styled.div`
  content: " ";
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,.5);
  z-index: 1000;
`


export const _OpenHouseModalContainer = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 20000;
  height: 500px;
  max-height: 100%;
  background: white;
  width: 100%;
  border-radius: 20px 20px 0 0;
`


export const _OpenHouse = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    flex-direction: column;
    gap: 10px;
  }
  ${({ isMobileApp }) => (
    isMobileApp ? `
     flex-direction: column;
     gap: 10px;
     align-items: center;
     position: relative;
    ` : ''
  )}
`

export const _Title = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
  margin: 32px 0 12px 0;

`
export const _Address = styled.div`
  color: ${TEXT_GREY};
  font-size: 14px;
  font-weight: 500;
  line-height: 45px;
  text-align: center;
  margin: 0 0 26px 0;


`
export const _OpenHouseItem = styled.div`
  height: 76px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: calc(50% - 6px);
  background-color: ${GREY_BACKGROUND};
  border-radius: 10px;
  padding: 12px 14px 12px 12px;
  div {
    text-align: left;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: 100%;
  }
  ${({ isMobileApp }) => (
    isMobileApp ? `
      width: calc(100% - 48px) !important;
    ` : ''
  )}
`
export const _DateTimeContainer = styled.div`


`

export const _Date = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  color: ${TEXT_GREY};
  margin-bottom: 8px;
`

export const _Time = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
`

export const _AddtoCalendar = styled.a`
  color: ${PRIMARY_SECONDARY_COLOR};
  font-size: 14px;
  font-weight: 500;
  line-height: 17.07px;
  cursor: pointer;

`

export const _CloseIcon = styled.div`
  position: absolute;
  top: 32px;
  right: 24px;
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

`
